module.exports = __webpack_public_path__ + "img/main.md.82c3f421.jpg";